__turbopack_context__.v({
  "cardGap": "Security-module__E5J8LG__cardGap",
  "cardHead": "Security-module__E5J8LG__cardHead",
  "cardTitle": "Security-module__E5J8LG__cardTitle",
  "googleSubCard": "Security-module__E5J8LG__googleSubCard",
  "hintLink": "Security-module__E5J8LG__hintLink",
  "labelDanger": "Security-module__E5J8LG__labelDanger",
  "row": "Security-module__E5J8LG__row" + " " + __turbopack_context__.i(391335)["row"] + " " + __turbopack_context__.i(391335)["rowStacked"],
  "rowAction": "Security-module__E5J8LG__rowAction",
  "rowActionDanger": "Security-module__E5J8LG__rowActionDanger",
  "rowMain": "Security-module__E5J8LG__rowMain" + " " + __turbopack_context__.i(391335)["rowMain"],
  "rowWrap": "Security-module__E5J8LG__rowWrap",
  "rows": "Security-module__E5J8LG__rows" + " " + __turbopack_context__.i(391335)["rows"],
  "value": "Security-module__E5J8LG__value" + " " + __turbopack_context__.i(391335)["rowValue"],
  "valueDanger": "Security-module__E5J8LG__valueDanger",
});
